import { useNavigate } from "react-router-dom";

import Button from "components/Button";
import { ModalSections } from "v2/components/billing/modals";
import SubmitButton from "components/SubmitButton";

import { useUser } from "routes/dataroutes/UserData";
import { ApiKeyActions } from "v2/api-key-management/routes/ApiKeysDataRoute";

import { cx } from "utils";


export default function NewApiKeyConfirmationModalContent() {
  const user = useUser();
  const navigate = useNavigate();

  const expirationDays = user?.apiKeyExpirationDays || 0;


  return (
    <>
      <ModalSections>
        <div>Are you sure you want to generate a new API key?</div>

        { expirationDays > 0 && (
          <div>
            Your current key will remain active for <span className="font-bold">{ expirationDays } more day{ (expirationDays > 1) && "s" }</span>.
            After that it will be disabled and you will only be able to scrape with the new key.
          </div>
        ) }

        { expirationDays === 0 && (
          <div>
            Your current key will be disabled immediately, so you won't be able to use that for scraping anymore.
          </div>
        ) }
      </ModalSections>
      <div className="flex justify-between gap-x-4 items-center">
        <SubmitButton
          text="New API Key"
          className={ cx("button button-primary", (expirationDays === 0) && "destructive") }
          size="SM"
          { ...ApiKeyActions.new_api_key }
        />
        <Button text="Cancel" className="button button-secondary" size="SM" onClick={ () => navigate(-1) }/>
      </div>
    </>
  );
};
